export const addDomainModal = {
  namespaced: true,
  actions: {
    show(ctx, params) {
      ctx.commit('setVisibility', true)
    },
    hide(ctx, params) {
      ctx.commit('setVisibility', false)
    },
  },
  state: () => ({
    isShow: false,
  }),
  mutations: {
    setVisibility(state, visibility) {
      state.isShow = visibility
    },
  },
}
